export const formatDisplayAmount = (value) => {
  if (value === '' || value === null || value === undefined) {
    return '';
  }

  const cleaned = String(value).replace(/,/g, '').trim();
  if (!cleaned || Number.isNaN(Number(cleaned))) {
    return String(value);
  }

  const num = Number(cleaned);
  return num.toLocaleString('en-US', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  });
};
